













import { Component, Vue, Prop } from 'vue-property-decorator';
import { IForm, IForgotPassword, IValidator, IValidations } from '@/interfaces';
import { ForgotPasswordValidator } from '@/validators';
import { FormMixinComponent } from '@/mixins';

import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import Btn from '@/components/Btn.vue';

@Component({
  name: 'forgot-password-form',
  components: { Field, TextField, Btn },
  mixins: [ FormMixinComponent ]
})
export default class ForgotPasswordFormComponent extends Vue implements IForm<IForgotPassword> {
  /**
   * To determine if this form is loading or not
   */
  @Prop({ type: Boolean, default: false }) public loading!: boolean;

  /**
   * The user we are creating
   */
  public model: IForgotPassword = { email: '' };

  /**
   * The validator we should use when checking validations
   */
  public validator = new ForgotPasswordValidator();

  /**
   * The saved validations so we can show them if needed
   */
  public validations: IValidations<IForgotPassword> | null = null;
}
